import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { NavHashLink } from 'react-router-hash-link';

import styles from './ActiveItem.module.css';

const ItemTypeStr = ({ type, itm, config, children, action, ...props }) => {
  const n = itm.url?.lastIndexOf('/');
  const resUrl = itm.url?.substring(n + 1);
  let html;
  switch (type) {
    case 'button':
      html = (
        <button type="button" {...props}>
          {children}
        </button>
      );
      break;
    case 'internal':
      if (itm.url) {
        if (resUrl.substring(0, 1) === '#') {
          html = (
            <NavHashLink smooth to={itm.url} onClick={() => action(false)} {...props}>
              {children}
            </NavHashLink>
          );
        } else {
          html = (
            <Link to={itm.url} type="button" onClick={() => action(false)} {...props}>
              {children}
            </Link>
          );
        }
      }
      break;
    case 'external':
      html = (
        <a href={itm.url_extension} type="button" target="_blank" rel="noreferrer" {...props}>
          {children}
        </a>
      );
      break;
    default:
      break;
  }
  return html;
};

export default function ActiveItem({ item, action }) {
  const { article, children } = item;
  // const [isShowing, setIsShowing] = useState(false);

  const renderChildItem = (key, itm, config = { style: styles.menuItem, isChild: true, action: () => {} }) => {
    let type = 'button';
    if (itm.url_extension) {
      type = 'external';
    }

    if (itm.url && itm.url !== '/') {
      type = 'internal';
    }
    return (
      <div className="w-full h-auto ">
        <div>
          <ItemTypeStr
            className="flex items-start font-semibold hd:text-[16px] xl:text-[14px] text-[16px] text-left"
            key={key}
            type={type}
            itm={itm}
            config={config.isChild}
            action={config.action}
          >
            <div className="mr-[12px] pt-[4px]">
              <img
                src={itm?.article?.article_assets[0]?.asset?.asset_file || 'https://bzpublishassets.blob.core.windows.net/media/assets/Supersoft_Icon.svg'}
                alt=""
                className="w-[32px] h-[24px]"
              />
            </div>
            <div className="hover:text-[#E12726]  border-b-2 border-white hover:border-[#E12726] transition-all">{itm.title}</div>
          </ItemTypeStr>
        </div>
      </div>
    );
  };

  // useEffect(() => {
  //   if (!isShowing && item) {
  //     setIsShowing(true);
  //   }
  // }, [isShowing, item]);

  return (
    <div className="border-t">
      <div className="  h-full mdl:max-w-[88%] hd:max-w-[90%] xl:max-w-[1200px] hdl:max-w-7xl hd2xl:max-w-[1440px] fhd:max-w-[1536px] mx-auto  ">
        <div className="w-full flex space-x-8  relative">
          <div className=" mt-8 w-full flex flex-wrap !items-start   !justify-between ">
            {children.map((itm) => {
              return (
                <div key={itm.id} className="hd:w-[244px] w-[200px] h-[58px] mb-4">
                  <div key={itm.title} className="flex  pl-0 pr-6  relative ">
                    {renderChildItem(itm.id, itm, { action })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="h-[56px] bg-[#F4F4F4] flex items-center justify-center">
        <div className="">
          Have a lot of questions? <span className="text-[#CC4019] underline">Get in touch</span>
        </div>
      </div>
    </div>
  );
}
